



























































































































import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "ButtonTwo"
})
export default class ButtonTwo extends Vue {}
